import * as motion from 'motion';
import { Controller } from 'stimulus';

export class AnnouncementsController extends Controller {
  static targets = ['inner', 'item'];
  static values = {
    delay: Number,
    interval: Number,
  };
  static interval = null;

  connect() {
    let index = 0;
    let direction = 'next';
    const { height } = this.itemTargets[0].getBoundingClientRect();

    this.interval = setInterval(() => {
      if (direction === 'next') {
        if (index < this.itemTargets.length - 1) {
          index++;
        } else {
          direction = 'prev';
        }
      }

      if (direction === 'prev') {
        if (index !== 0) {
          index--;
        } else {
          direction = 'next';
        }
      }

      motion.animate(this.innerTarget, { transform: `translateY(-${index * height}px)` });
    }, this.delayValue * 1000);
  }
}

window.Stimulus.register('announcements', AnnouncementsController);
